import { ITemplate } from "../../types";
import { Main, Card, Header, Wrapper, Box } from "./styled";

import BadgeConnector from "utils/project/connector-badge";

interface IProps {
  template: ITemplate;
  setViewMode: (view: "RESUMED" | "DETAILED") => void;
}

export function DetailedView({ template, setViewMode }: IProps) {
  return (
    <Main>
      {template.activities.map((activity) => (
        <Card>
          <Header>{activity.name}</Header>
          <Wrapper>
            <Box>
              <span style={{ fontSize: "14px" }}>Conectores</span>
              <div style={{ display: "flex", flexDirection: "row" }}>
                {activity.connectors.map((connector, i) => (
                  <BadgeConnector name={connector.name} index={i} />
                ))}
              </div>
            </Box>
            <Box>
              <span style={{ fontSize: "14px" }}>Apps</span>
              <div style={{ display: "flex", flexDirection: "row" }}>
                {/* <BadgeConnector name={"Teste_1"} index={0} />
                <BadgeConnector name={"Teste_2"} index={1} /> */}
              </div>
            </Box>
          </Wrapper>
          <div
            style={{
              borderRadius: "100px",
              color: "#2E7D32",
              backgroundColor: "#2E7D3214",
              width: "fit-content",
              padding: "6px 10px",
              fontSize: "12px",
              position: "absolute",
              top: "30px",
              right: "30px",
            }}
          >
            Finalizado
          </div>
        </Card>
      ))}
    </Main>
  );
}
